module.exports = __webpack_public_path__ + "media/maps-markers/red-pin-fb464043.svg";